import styled from 'styled-components';

// PM analitik P5 — E12 yerleşimi: ortak pano ızgarası (performance-operations/styles) + liste süzgeç satırı. Renk/yazı tema token'ı.

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 12px;
`;

export const FilterField = styled.div`
  width: 220px;
  max-width: 100%;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ListWrap = styled.div`
  grid-column: span 12;
  min-width: 0;
`;

export const TabBar = styled.div`
  margin-bottom: 4px;
`;

export const Note = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.xs};
  color: ${({ theme }) => theme.colors.text.muted};
  margin-bottom: 12px;
`;
